import DOMPurify from 'isomorphic-dompurify';
import React from 'react';

export class HtmlParseComponent extends React.Component<any, any> {
  render() {
    const richText = this.props.richText;
    const createMarkup = (content: any) => {
      const clean = DOMPurify.sanitize(content);
      return { __html: clean };
    }

    return (
      <div className={this.props.isRichText ? 'htmlParseDiv' : 'parsingDiv'}
        dangerouslySetInnerHTML={createMarkup(richText)}>
      </div>
    );
  }
}
export default HtmlParseComponent;
